module.exports = __webpack_public_path__ + "img/atmosfera.e06da30.png";